import { styled, Typography } from "@mui/material";

export const OverlayContainer = styled("div")({
  width: "100%",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontWeight: 300,
  fontSize: 20,
  marginTop: 40,
  marginLeft: 32,
  color: theme.palette.primary.dark,
}));
